import { RL_SUPPORT_ROLE } from "Constants";
import { useGetWhoamiQuery, useUploadConfigQuery } from "Services";
import { FileType } from "Types";
import useUsageQuota from "./useUsageQuota";

type FileUploadChecks = {
  isSupportRole: boolean;
  checksAreLoading: boolean;
  hasSufficientCapacity: boolean;
  isOverSizeLimit: boolean;
  sizeLimit: number;
  remainingCapacity: number;
  remainingAfterUpload: number;
  maxVersions: number;
};

const useFileUploadChecks = (
  fileType: FileType,
  fileSize: number | null,
): FileUploadChecks => {
  const { data: whoami } = useGetWhoamiQuery();
  const { total, used, isLoading: usageIsLoading } = useUsageQuota(fileType);
  const {
    data: config = {
      size_limit: 1024 * 1024 * 1024 * 10,
      max_versions_per_package: 0,
    },
    isLoading: configIsLoading,
  } = useUploadConfigQuery();
  const remainingCapacity = total > used ? total - used : 0;
  const isSupportRole = whoami?.org_role === RL_SUPPORT_ROLE.value;

  return {
    isSupportRole,
    remainingCapacity,
    checksAreLoading: usageIsLoading || configIsLoading,
    hasSufficientCapacity: fileSize
      ? fileSize <= remainingCapacity || isSupportRole
      : true,
    isOverSizeLimit: fileSize ? fileSize > config.size_limit : false,
    remainingAfterUpload: isSupportRole
      ? remainingCapacity
      : remainingCapacity - (fileSize ?? 0),
    sizeLimit: config.size_limit,
    maxVersions: config.max_versions_per_package,
  };
};

export default useFileUploadChecks;
